import {LISTER_GROUPES_STORE, SAVE_GROUPE_STORE, UPDATE_GROUPE_STORE, TOGGLE_MODAL_GROUPE, DELETE_GROUPE_STORE} from '../actions'

const initialState = {
    groupes: [],
    groupe: {},
    totalItems: 0,
    showModal: false
}
export default (state = initialState, action = {})=>{

    switch (action.type) {
        
        case LISTER_GROUPES_STORE: {
            return {
                ...state,
                groupes: action.groupes,
                totalItems:action.totalItems
            }
        }

        case SAVE_GROUPE_STORE: {
            return {
                ...state,
                groupes: [action.groupe,...state.groupes ]
            }
        }

        case UPDATE_GROUPE_STORE: {
            return {
                ...state,
                groupes: state.groupes.map(item=>item.id == action.groupe.id ? action.groupe : item)
            }
        }

        case TOGGLE_MODAL_GROUPE: {
            return {
                ...state,
                showModal: !state.showModal
            }
        }

        case DELETE_GROUPE_STORE: {
            return {
                ...state,
                groupes: state.groupes.filter(item=>item.id != action.groupe.id)
            }
        }
    
        default:
           return state;
    }
}